
import Vue from "vue";
import { IInvoiceData } from "../types";
import AppPropsMixin from "@/components/mixins/AppPropsMixin.vue";
import InvoiceSelectorList from "@/components/InvoiceSelectorList.vue";
import store from "../store";

export default Vue.extend({
  name: "invoice-selector",
  mixins: [AppPropsMixin],
  components: { InvoiceSelectorList },
  data: function() {
    return {
      valueLocal: false as boolean
    };
  },
  props: {
    value: { type: Boolean, default: false }
  },
  computed: {
    invoiceSelections(): IInvoiceData[] {
      //@ts-ignore
      return store.getters.invoiceModule.getInvoiceSelections;
    },
    refNumber(): string {
      let refNumber: string = "";
      if (this.invoiceSelections.length > 0) {
        refNumber = this.invoiceSelections[0].referenceNumber;
      }
      return refNumber;
    }
  },
  watch: {
    value(newValue: boolean) {
      this.valueLocal = newValue;
    },
    valueLocal(newValue: boolean) {
      this.$emit("input", newValue);
    }
  }
});
